module.exports = __webpack_public_path__ + "img/k4.fd1f50bc.png";